module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Bold.c5f0ebb2.eot";